import React, { useState } from "react";

import Paper from "../../UI/Paper";

//MUI
import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function ClientInvoiceBundleWorkflows() {
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };
  return (
    <>
      <Paper elevation={0}>
        <Tabs
          value={tabIndex}
          onChange={handleTabSwitch}
          sx={{ marginBottom: "2rem" }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="workflow1" />
        </Tabs>

        <TabPanel value={tabIndex} index={0} id="tabPanel0">
          <h1>not implemented :(</h1>
        </TabPanel>
      </Paper>
    </>
  );
}
